import React from "react";
import AboutHeroSection from "./AboutHeroSection";
import AboutAreaSection from "./AboutAreaSection";
import MissionVisionAreaSecton from "./MissionVisionAreaSecton";
import TestimonialSlider from "./TestimonialSlider";
import CoreValues from "./CoreValues";

const About = () => {
  return (
    <>
      <AboutHeroSection />
      <AboutAreaSection />
      <MissionVisionAreaSecton />
      <TestimonialSlider />
      <CoreValues />
    </>
  );
};

export default About;
